import { DatePipe, Location } from '@angular/common';
import { VoceProgetto } from '../Models/VoceProgetto';
import { ApiRestService } from '../_services/api-rest.service';
import { ApiRestService as primaNotaApi } from '../../Prima_Nota/_services/api-rest.service';
import { ApiRestService as ApiClienti } from '../../Admin/_service/api-rest.service';
import { Azienda } from '../../Admin/models/Azienda';
import { ProgettiStoreService } from '../_services/progetti-store.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Progetto } from '../Models/Progetto';
import { PersonaleStoreService } from 'src/app/Admin/_service/personale-store.service';
import { AziendeStoreService } from 'src/app/Admin/_service/aziende-store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { Persona } from '../../Admin/models/persona';
import { ToastrService } from 'ngx-toastr';
import { FileStoreService } from "../../shared/_services/file-store.service";
import { InterventiStoreService } from "../../Interventi/_services/interventi-store.service";
import { environment } from 'src/environments/environment';
import { Permission } from "../../Login/_guards/Permission";
import { IDropdownSettings } from "../../../LibrerieCustom/MultiselectDropdown";
import { ApiPathsService } from "../../api-paths.service";
import { ApiRestService as RmaApiRestService } from "../../rma/_services/api-rest.service";
import { ApiRestService as SharedApiRestService } from "../../shared/_services/api-rest.service"

@Component({
  selector: 'app-progetto',
  templateUrl: './progetto.component.html'
})

export class ProgettoComponent implements OnInit {
  environment = environment;
  Stampe: any[];
  private CercainAdhoc: boolean = false;
  disableSave: boolean = false;
  banche: any[];
  Email: any;
  id_offerta: any;
  genericFiles: any[] = [];
  TipoOfferta: any;
  restRoute: void;

  constructor(
    private ApiRestService: ApiRestService,
    private rmaApiRestService: RmaApiRestService,
    private progettiStore: ProgettiStoreService,
    public aziendeStore: AziendeStoreService,
    private primanotaApi: primaNotaApi,
    private apiClienti: ApiClienti,
    private personaleStore: PersonaleStoreService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastrService,
    private datepipe: DatePipe,
    private filestore: FileStoreService,
    private InterventiStore: InterventiStoreService,
    public permission: Permission,
    private apiPath: ApiPathsService,
    private ngbModal: NgbModal,
    public campoUtility: CampoUtility,
    private sharedapirest: SharedApiRestService,
    private downloadService: DownloadService,
    private location: Location,
    private authSvc: AuthenticationService,
    private fileStore: FileStoreService,
  ) {
  }

  isModifyDisabled: boolean = false;
  VociDiCosto: VoceProgetto[] = [];
  clienti: Azienda[] = [];
  managers: Persona[] = [];
  Agenti: Persona[] = [];
  clienteSelezionato: Azienda = null;
  clientidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    singleOutput: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nominativo',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
    noDataAvailablePlaceholderText: "Nessun Cliente trovato ",
    moreButton: this.environment.ClientiAddOn.codAdhoc,
    moreButtonText: "Cerca in AdHoc"
  };
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
    singleOutput: true,
    allowSearchFilter: true,
  };
  idnomedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    singleOutput: true,
    idField: 'id',
    textField: 'nome',
    allowSearchFilter: true,
  };
  subscriptions: Subscription = new Subscription();
  isAddable: boolean;
  isEditable: boolean;
  ProgettoSelezionato: Progetto = new Progetto();
  form: FormGroup;
  submitted: boolean;
  count: number = 0;
  colore: any;
  tipiPagamento: any[] = [];
  DropdownSources: any = { sediAdhoc: [], Agenti: [], managers: [], TipiProgetti: [] };
  nuovoCliente: Azienda = new Azienda();
  isPreventivo = Progetto.IsPreventivo(new Progetto());
  get f() { return this.form.controls; }

  Init() {
    this.route.params.subscribe(data => {
      this.id_offerta = this.id_offerta ?? data['id'];
      this.TipoOfferta = this.environment.ProgettiAddon['TipiProgetto']?.find(x => x.id == data['tipo']);
      this.restRoute = this.TipoOfferta?.restRoute ?? '/progetti/progetti';
      console.log('Id Offerta RouteParam:', this.id_offerta);
    });
    this.count = 0;
    if (!this.isModifyDisabled && this.permission.isPermitted('menu-clienti'))
      this.aziendeStore.getListaAziende(new RicercaPaginazione('', 0, 1, 'C'));
    this.personaleStore.getListaPersonale(new RicercaPaginazione("", 0, 1));
    this.subscriptions.add(this.progettiStore.$showAddForm.subscribe(x => this.isAddable = x));
    this.subscriptions.add(this.progettiStore.$editable.subscribe(x => this.isEditable = x));
    this.subscriptions.add(this.progettiStore.stampe.subscribe(x => this.Stampe = x ?? []));
    this.subscriptions.add(this.progettiStore.email.subscribe(x => this.Email = x ?? []));

    this.InitTipiProgetti();
    if (environment.ProgettiAddon.CampiOfferta.find(x => x['source'] == 'Agenti')) {
      this.subscriptions.add(this.apiPath.ClassicGet('/anagrafica/clienti/agenti').subscribe(data => {
        this.Agenti = data.map(x => {
          var agente = {};
          Object.getOwnPropertyNames(x)?.forEach(prop => {
            agente[prop] = x[prop];
          })
          agente['fullName'] = x['nome'];
          return agente;
        }) ?? [];
        this.DropdownSources.Agenti = this.Agenti;
      }))
    }
    this.subscriptions.add(this.aziendeStore.$listaAziende.subscribe(data => this.clienti = data?.data ?? []));
    this.subscriptions.add(this.personaleStore.$listaPersonale.subscribe(data => {
      this.managers = data?.data ?? [];
      var ds = this.DropdownSources;
      ds.managers = data?.data ?? [];

      this.DropdownSources = Object.assign({}, ds);


    }));
    if (environment.ProgettiAddon['tipoPagamento'])
      this.subscriptions.add(this.apiPath.ClassicGet(`${this.restRoute}/pagamenti`).subscribe(data => {
        this.tipiPagamento = data ?? []
      }));

    if (environment.ProgettiAddon['banche'])
      this.subscriptions.add(this.apiPath.ClassicGet(`${this.restRoute}/banche`).subscribe(data => {
        this.banche = data ?? []
      }));

    if (this.id_offerta) {
      this.isEditable = true;
      this.isAddable = false;
      this.ApiRestService.getUnitaDiMisura().subscribe(um => {
        this.ApiRestService.getInfoProgetto({ id: this.id_offerta }, this.restRoute).subscribe(async data => {
          if (environment.ProgettiAddon['genericFiles'] && this.id_offerta) {
            this.apiPath.ClassicPost(`${this.restRoute}/files`, { id: this.id_offerta }).subscribe(data => this.genericFiles = data);
          }
          var progetto = data.data;
          this.Stampe = data.stampe;
          this.Email = data.invio;
          progetto?.progetti?.forEach(sottoProgetto => {
            if (sottoProgetto) {
              sottoProgetto.sede_id = sottoProgetto.sede_id ? sottoProgetto.sede_id : null;
              sottoProgetto?.voci?.forEach((item: VoceProgetto) => {
                if (item.prodotto_id) {
                  this.ApiRestService.getInfoProdotto({ id: item.prodotto_id }).subscribe(prodotto => {
                    item.um_list = prodotto.prezzi.map(x => { return { id: x.um.toString(), label: x.umlabel } });
                    item.umSelezionabili = item.um_list;
                    if (item.um_id > 0)
                      item.um = item.um_list?.filter(data => data?.id?.toString() == item?.um_id?.toString()) ?? [];
                  })
                } else {
                  item.um_list = um // item?.prezzi?.length > 0 ? item.prezzi.map(x=> {return {id: x.um.toString(), label: x.umlabel}}) : um;
                  item.umSelezionabili = item.um_list;
                  if (item.um_id > 0) {
                    item.um = item.um_list?.filter(data => data?.id?.toString() == item?.um_id?.toString()) ?? [];
                  }
                }
                if (!item['tipo'])
                  this.DropdownSources?.TipiProgetti?.forEach(tipoProgetto => {
                    if (tipoProgetto?.VociFields?.every(v => item[v.nome] == v.value))
                      item['tipoProgetto'] = tipoProgetto;
                  })
              });
              if (!progetto['tipo']) {
                progetto['tipoProgetto'] = this.GetTipoProgetto(sottoProgetto);
                sottoProgetto['tipoProgetto'] = this.GetTipoProgetto(sottoProgetto);
              } else {
                var tipo = this.environment.ProgettiAddon['TipiProgetto']?.find(x => x.id == progetto['tipo'])
                progetto['tipoProgetto'] = tipo;
                sottoProgetto['tipoProgetto'] = tipo;
              }

            }
          });
          this.ProgettoSelezionato = progetto;
          console.log(this.ProgettoSelezionato);
          this.compilaForm(progetto);
          this.filestore.SetListaFile(progetto.files);
          // this.filestore.updateSelectedUrl('/progetti/progetti/file');
          this.filestore.SelectSection('progetti');
          if (this.ProgettoSelezionato?.progetti?.length > 0 && this.permission.isPermitted('menu-fasi'))
            this.InterventiStore.getInterventi(this.ProgettoSelezionato?.progetti[0], 'Progetto');
        });
      })
    }
    else {
      this.isAddable = true;
      this.isEditable = false;
      if (!this.permission.HasnotCapacity(['is-cliente-ordine']))
        this.clienteSelezionato = { id: this.authSvc.currentUserValue.id, nominativo: this.authSvc.currentUserValue.fullName };
      const now = new Date();
      this.ProgettoSelezionato.data_creazione = this.datepipe.transform(now, 'yyyy-MM-dd');
      this.form?.controls?.data_creazione?.setValue(this.datepipe.transform(now, 'yyyy-MM-dd'));
      if (this.environment.ProgettiAddon['CustomNumOfferta']) {
        var value = this.environment.ProgettiAddon['CustomNumOfferta'];
        if (value.includes('${progressivo}')) {
          this.apiPath.ClassicGet(`${this.restRoute}/progressivo`).subscribe(progressivo => {
            progressivo.forEach((val: { id: number, label: string }) => {
              this.ProgettoSelezionato.codice = value.replace('${progressivo}', val.label);
            })
          });

        }
      }
      this.newSubOfferta();
    }

  }
  GetTipoProgetto(sottoprogetto: Progetto) {
    var types = []
    sottoprogetto.voci.forEach(voce => {
      if (voce['tipoProgetto']) types.push(voce['tipoProgetto'])
    })
    return types?.find(x => x != undefined);
  }
  InitTipiProgetti() {
    var tipiProgetti = environment.ProgettiAddon['TipiProgetto']?.filter(x => this.permission.HasCapacity(x.capacita));
    if (!(tipiProgetti?.length > 0)) return;
    this.DropdownSources.TipiProgetti = tipiProgetti;
  }
  ngOnInit() {
    this.Init()
  }
  compilaForm(item: Progetto) {
    this.isModifyDisabled = item.data_emissione ? true : this.isModifyDisabled;
    this.isPreventivo = Object.assign({}, { preventivo: Progetto.IsPreventivo(this.ProgettoSelezionato) })?.preventivo;
    console.log(this.isPreventivo)
    this.clienteSelezionato = item.clienteObject;
    this.ProgettoSelezionato.data_creazione = this.datepipe.transform(item.data_creazione, 'yyyy-MM-dd');
    this.ProgettoSelezionato.data_emissione = this.datepipe.transform(item.data_emissione, 'yyyy-MM-dd');
    this.ProgettoSelezionato.data_accettazione = this.datepipe.transform(item.data_accettazione, 'yyyy-MM-dd');
    this.ProgettoSelezionato.data_conferma = this.datepipe.transform(item.data_conferma, 'yyyy-MM-dd');
    this.getProveAcquistoPreventivo(item);
  }
  getDaForm(): Progetto {
    const progetto = this.ProgettoSelezionato ?? new Progetto();
    progetto.oggetto = this.ProgettoSelezionato.oggetto ? this.ProgettoSelezionato.oggetto : "BackOffice";
    progetto.gestore = progetto.gestoreObject?.id;
    progetto.manager = progetto?.managerObject?.id;
    progetto.cliente = this.clienteSelezionato?.id;
    progetto['tipo'] = progetto['tipoProgetto']?.id;
    progetto.id_segnalatore = progetto.segnalatore?.id;
    progetto.id_commerciale = progetto.commerciale?.id;
    progetto.colore = progetto.colore ?? "#239d00";
    this.ProgettoSelezionato?.progetti?.forEach(sottoOfferta => {
      sottoOfferta.blocchi = sottoOfferta?.blocchi?.filter(x => x.checked);
      if (sottoOfferta?.consegna)
        Object.getOwnPropertyNames(sottoOfferta.consegna)?.forEach(prop => {
          sottoOfferta.consegna[prop] = typeof sottoOfferta.consegna[prop] === 'string' ? sottoOfferta.consegna[prop].toUpperCase() : sottoOfferta.consegna[prop];
        })
    })
    console.log(progetto);
    return progetto
  }



  FilterHandler(filterType: string, searchString: string) {
    switch (filterType) {
      case "filtroManager":
        this.filtroManager(searchString);
        break;
      case "filtroCliente":
        this.filtroCliente(searchString);
        break;
      case "filtrosegnalatore":
        this.filtrosegnalatore(searchString);
        break;
      case "filtroCommerciale":
        this.filtroCommerciale(searchString);
        break;
    }

  }
  fileDiProgetto(file): boolean {
    return (this.ProgettoSelezionato?.files?.findIndex(x => x.id == file.id) > -1) ?? false;
  }

  filtroCliente(item: string) {
    if (item.length >= 3) {
      this.CercainAdhoc = false;
      this.aziendeStore.getListaAziende(new RicercaPaginazione(item, 0, 1));
    }
  }
  filtroManager(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaPersonale(new RicercaPaginazione(item, 0, 1));
    }
  }
  filtrosegnalatore(item: string) {
    if (item.length >= 3) {
      this.aziendeStore.getListaAziende(new RicercaPaginazione(item, 0, 1));
    }
  }
  filtroCommerciale(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaPersonale(new RicercaPaginazione(item, 0, 1));
    }
  }
  saveClick(close?: boolean) {
    this.disableSave = true;
    console.log("Cerca in AdHoc: ", this.CercainAdhoc);
    console.log("Cliente selezionato: ", this.clienteSelezionato);
    this.ProgettoSelezionato['agente'] = this.ProgettoSelezionato['agenteObject']?.id;

    if (this.clienteSelezionato && !this.CercainAdhoc)
      this.save(close);
    else if (this.clienteSelezionato && this.CercainAdhoc) {
      this.apiClienti.getTipiSedi().subscribe(tipisede => {
        this.clienteSelezionato.ruoli = ["C"];
        this.clienteSelezionato.tipiSede = [tipisede[0].id];
        this.apiClienti.addNewCompany(this.clienteSelezionato).subscribe(cliente => {
          this.CercainAdhoc = false;
          this.clienteSelezionato = cliente;
          this.save(close);
        })
      })
    }
    else if (this.nuovoCliente.nominativo?.length > 0) {
      this.nuovoCliente.ruoli = ["C"];
      this.apiClienti.getTipiSedi().subscribe(tipisede => {
        this.nuovoCliente.tipiSede = [tipisede[0].id]
        this.apiClienti.addNewCompany(this.nuovoCliente).subscribe(cliente => {
          this.clienteSelezionato = cliente;
          this.save(close);
        })
      })
    }
    else {
      this.toastService.error("Indicare un cliente o inserire la ragione sociale per crearne uno nuovo")
    }
  }

  getObject(campo: CampoAggiuntivo, i: number, progetto: Progetto) {
    if (campo.type == 'object' && progetto[campo.oggetti[i]] && progetto[campo.oggetti[i]][campo.field[i]] && typeof progetto[campo.oggetti[i]][campo.field[i]] !== 'string')
      return campo.field[i + 1] ? progetto[campo.oggetti[i]][campo.field[i]][campo.field[i + 1]] : {}
    else if (progetto[campo.oggetti[i]] && (campo.type == 'object' || typeof progetto[campo.oggetti[i]] !== 'string') && campo?.field?.length > i)
      return progetto[campo.oggetti[i]][campo.field[i]]
    else
      return progetto[campo.oggetti[i]]
  }

  save(close?: boolean) {
    if (this.isAddable) {
      this.ApiRestService.addProgetti(this.getDaForm(), this.restRoute).subscribe(data => {
        if (this.isPreventivo)
          this.saveProvaAcquisto(Object.assign({}, this.ProgettoSelezionato), data)
        if (data.data_conferma)
          this.ApiRestService.updateProgetti(data, this.restRoute).subscribe();
        if (close)
          this.goBack();
        else {
          //this.progettiStore.updateEditable(true)
          //this.progettiStore.updateShowAddForm(false)
          /*this.progettiStore.updateProgettoSelezionato({id: data.id});*/
          console.log("Add response: ", data);
          this.id_offerta = data.id;
          this.Init();
          this.isEditable = true;
          this.isAddable = false;
          this.disableSave = false;
        }
      });
    } else if (this.isEditable) {
      this.ApiRestService.updateProgetti(this.getDaForm(), this.restRoute).subscribe((data) => {
        if (this.isPreventivo)
          this.saveProvaAcquisto(Object.assign({}, this.ProgettoSelezionato), data)
        if (close)
          this.goBack();
        else {
          /*this.progettiStore.updateProgettoSelezionato(this.getDaForm());*/
          this.Init();
          this.toastService.success("Modifiche apportate", "Success!!")
          this.disableSave = false;
        }
      });
    }
  }

  saveProvaAcquisto(progetto: Progetto, response?: Progetto) {
    progetto?.progetti?.forEach((sottoprogetto, i) => {
      if (sottoprogetto?.proveAcquisto?.length > 0 && sottoprogetto?.proveAcquisto[0]?.id) {
        var PA = sottoprogetto?.proveAcquisto[0];
        PA.acquirente = new Azienda();
        PA.acquirente.indirizzo = sottoprogetto?.provaAcquisto?.indirizzo;
        PA.acquirente.citta = sottoprogetto?.provaAcquisto?.citta;
        PA.acquirente.cap = sottoprogetto?.provaAcquisto?.cap;
        PA.acquirente.provincia = sottoprogetto?.provaAcquisto?.provincia;

        this.rmaApiRestService.editProvaAcquisto(PA).subscribe();
      }
      else {
        let _form: FormData = new FormData();
        _form.append("progetto", (response?.progetti[i]?.id)?.toString())
        if (sottoprogetto?.provaAcquisto?.indirizzo)
          _form.append("acquirente[indirizzo]", sottoprogetto?.provaAcquisto?.indirizzo)
        if (sottoprogetto?.provaAcquisto?.citta)
          _form.append("acquirente[citta]", sottoprogetto?.provaAcquisto?.citta)
        if (sottoprogetto?.provaAcquisto?.cap)
          _form.append("acquirente[cap]", sottoprogetto?.provaAcquisto?.cap)
        if (sottoprogetto?.provaAcquisto?.provincia)
          _form.append("acquirente[provincia]", sottoprogetto?.provaAcquisto?.provincia)
        this.apiPath.MultipartSendRequest(_form, this.apiPath.getBaseAPI() + "/rma/register/add")
      }
    });
  }

  getProveAcquistoPreventivo(progetto: Progetto) {
    if (!this.isPreventivo) return;
    progetto?.progetti?.forEach(sottoprogetto => {
      this.rmaApiRestService.getProveAcquistoProgetto({ id: sottoprogetto?.id }).subscribe(data => {
        sottoprogetto.proveAcquisto = data?.data ?? [];
        sottoprogetto.provaAcquisto = data?.data.find(x => true)?.acquirente ?? {};
        sottoprogetto.hide = data?.data.find(x => true)?.acquirente != undefined && sottoprogetto.prezzo && sottoprogetto.attivita.find(x => x.risposta) != undefined;
      })
    })
  }


  goBack() {
    this.progettiStore.updateEditable(false);
    this.progettiStore.updateShowAddForm(false);
    this.location.back();
    //this.router.navigate([this.route.snapshot.queryParams[' progetti/progetti '] || 'progetti/progetti',]);
  }
  OpenGantt() {
    this.router.navigate([this.route.snapshot.queryParams[' /interventi/gantt/' + this.ProgettoSelezionato.id.toString()] || '/interventi/gantt/' + this.ProgettoSelezionato.id.toString(),]);
  }
  CreaFattura() {
    this.primanotaApi.generateFattura(this.ProgettoSelezionato.id).subscribe(() => {
      this.toastService.success("Fattura Creata Correttamente!", "Yess!");
    })
  }
  TaskCompleted = [];
  newSubOfferta() {
    var sottoprogetto = new Progetto();
    this.TaskCompleted = [];
    var sezione = environment.ProgettiAddon['CampiSottoOffertaPreventivo']?.find(x => x['campi']?.find(y => y['type'] == 'checkboxArray' || y['type'] == 'checkboxArrayMEXC'));
    if (sezione)
      var checkboxArray = sezione['campi']?.filter(y => y['type'] == 'checkboxArray' || y['type'] == 'checkboxArrayMEXC');
    if (checkboxArray?.length > 0)
      checkboxArray.forEach(campoAgg => {
        var tipoCheck = campoAgg?.oggetti[0];
        this.rmaApiRestService.GetCampiAggiuntiviRmas(null, tipoCheck).subscribe(data => {
          this.TaskCompleted.push(tipoCheck);
          sottoprogetto[tipoCheck] = data;
          if (this.TaskCompleted?.length >= checkboxArray?.length) {
            sottoprogetto.provaAcquisto = {};
            this.createProgetto(sottoprogetto)
          }
        })
      });

    else
      this.createProgetto(sottoprogetto)
  }

  private createProgetto(sottoprogetto: Progetto) {
    this.ProgettoSelezionato = this.ProgettoSelezionato ?? new Progetto();
    if (this.ProgettoSelezionato?.progetti)
      this.ProgettoSelezionato?.progetti?.push(sottoprogetto);
    else
      this.ProgettoSelezionato.progetti = [sottoprogetto];
    console.log('Sottoprogetti: ', this.ProgettoSelezionato.progetti);
  }

  deleteSubOfferta(event: MouseEvent, toRemove: Progetto) {
    this.ProgettoSelezionato.progetti = this.ProgettoSelezionato.progetti.filter(item => item !== toRemove);
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  clientecambiato(_cliente: Azienda) {
    console.log('Cliente Selezionato: ', _cliente)

    this.SetClienteData(_cliente);

  }
  SetClienteData(_cliente: Azienda) {
    if (this.isAddable && !this.ProgettoSelezionato) {
      this.ProgettoSelezionato = new Progetto();
      this.ProgettoSelezionato.progetti = [new Progetto()];
    }
    if (_cliente) {
      this.ProgettoSelezionato.clienteObject = _cliente;
      _cliente.email = _cliente.email?.toString().split(';').join('\n')
    }
    if (_cliente?.id && environment.ProgettiAddon.CampiOfferta.find(x => x['source'] == 'Agenti'))
      this.ProgettoSelezionato['agenteObject'] = _cliente['agenteObject'] ?? (_cliente['agenteAdhoc'] ? this.Agenti?.find(x => x['codice'] == _cliente['agenteAdhoc']) : undefined);
    if (_cliente?.id && environment.ProgettiAddon['tipoPagamento'])
      this.ProgettoSelezionato?.progetti?.forEach(sottoProgetto => {
        sottoProgetto.pagamentoObject = _cliente['pagamentoObject'] ?? (_cliente['pagAdhoc'] ? this.tipiPagamento?.find(x => x['codice'] == _cliente['pagAdhoc']) : undefined);
      })
    this.SetFido(_cliente);
    if (this.isAddable)
      this.ProgettoSelezionato.progetti[0].checkAmm = this.clienteSelezionato?.checkAmm;
    this.GetSediAdHoc(_cliente);
  }
  GetSediAdHoc(_cliente: Azienda) {
    if (!_cliente?.id) return;
    if (!environment.ProgettiAddon.CampiSottoOfferta.find(x => x['internalOutput'] == "sedeObjectAdhoc")) return;
    var param = !this.CercainAdhoc ? { id: _cliente?.id } : { codAdhoc: _cliente?.codAdhoc };
    this.apiPath.ClassicPost('/anagrafica/clienti/sedi/adhoc', param).subscribe(data => {
      this.DropdownSources.sediAdhoc = data ?? [];
      this.ProgettoSelezionato?.progetti?.forEach(sottoprogetto => {
        if (
          sottoprogetto &&
          !sottoprogetto.francoDeposito &&
          (
            !sottoprogetto["consegna"] ||
            sottoprogetto["consegna"]?.codAdhoc != null
          ) &&
          (
            !sottoprogetto["sedeObjectAdhoc"] ||
            sottoprogetto["sedeObjectAdhoc"]?.codAdhoc == '' ||
            data?.find(x => x.codAdhoc == sottoprogetto["sedeObjectAdhoc"]?.codAdhoc) == undefined
          )
        )
          sottoprogetto["sedeObjectAdhoc"] = data?.find(x => true);
      })
      console.log('SediAdhoc: ', data)
    });
  }
  SetFido(_cliente: Azienda) {
    if (!_cliente?.id) return;
    var campiAggiuntivi = [...environment.ProgettiAddon.CampiSottoOfferta, ...environment.ProgettiAddon.CampiOfferta];
    var fidoAssicurativo = campiAggiuntivi.find(x => x.oggetti.includes('fidoAssicurativo'));
    var fido = campiAggiuntivi.find(x => x.oggetti.includes('fido'));
    if (fido) {
      this.ProgettoSelezionato.progetti.forEach(sottoProgetto => sottoProgetto['fido'] = _cliente['fido'])
      this.ProgettoSelezionato['fido'] = _cliente['fido']
    }
    if (fidoAssicurativo) {
      this.ProgettoSelezionato.progetti.forEach(sottoProgetto => sottoProgetto['fidoAssicurativo'] = _cliente['fidoAmm'])
      this.ProgettoSelezionato['fidoAssicurativo'] = _cliente['fidoAmm']
    }
  }
  onFileChanged() {
    this.filestore.SetListaFile(this.ProgettoSelezionato.files);
    this.filestore.SelectSection('progetti');
    //this.progettiStore.updateProgettoSelezionato(this.ProgettoSelezionato);
    this.refresh()
  }

  refresh() {
    //this.progettiStore.updateProgettoSelezionato(this.ProgettoSelezionato);
    this.Init();
  }

  CercaAdhoc(item: Azienda) {
    this.CercainAdhoc = true;
    if (!this.environment.ClientiAddOn.codAdhoc) {
      this.toastService.warning("Questa funzione non è disponibile in questa piattaforma");
      return;
    }
    this.aziendeStore.getListaAziende({ nome: item?.nominativo?.toString() ?? '', page: 0, size: 1, adhoc: true });
  }

  NewRevisione() {
    this.apiPath.ClassicPost(`${this.restRoute}/newrev`, { id: this.ProgettoSelezionato.id }).subscribe(data => {
      if (data?.id) {
        this.id_offerta = data.id;
        this.Init();
        this.toastService.success(` Revisione ${data.rev} creata con successo`);
      }
      else
        this.toastService.warning("Errore nell'apertura del nuovo ordine, Verificare la presenza nella lista ordini")
    })
  }

  pagamentoChange(item: Progetto) {
    if (item)
      item.pagamento = item.pagamentoObject?.id;
  }


  ChangeHandler(item: Progetto, event: { OnChange: string, Event: any }) {
    switch (event.OnChange) {
      case 'SedeAdhocChange':
        if (event.Event) {
          if (!item.consegna)
            item.consegna = { id: null };
          item.consegna.nominativo = item['sedeObjectAdhoc'].nominativo ?? "";
          Object.getOwnPropertyNames(event.Event)?.forEach(prop => {
            if (prop != 'telefono' || !item.consegna.telefono)
              item.consegna[prop] = event.Event[prop] ?? (item.consegna[prop] ?? "");
          })
        }
        else {
          // item.consegna = new Azienda();
          item.consegna.codAdhoc = null;
        }
        break;
      case "getPrice":
        item.prezzo = this.campoUtility.getChecklistPrice(item.attivita);
        break;

      case 'OnFidoAssicurativoChange':
        this.apiPath.ClassicPost('/anagrafica/clienti/get', { id: this.ProgettoSelezionato.clienteObject?.id }).subscribe((cliente) => {
          this.SetClienteData(cliente);
        });
        break;
      case 'OnTipoChange':
        this.ProgettoSelezionato.colore = this.ProgettoSelezionato['tipoProgetto']?.colore ?? this.ProgettoSelezionato.colore;
        this.ProgettoSelezionato.progetti.forEach(sottoProgetto => sottoProgetto['tipoProgetto'] = this.ProgettoSelezionato['tipoProgetto']);
        break;
    }

  }


  TotalePreventivo(): number {
    let tot: number = 0;
    this.ProgettoSelezionato.progetti.forEach(sottoProgetto => {
      tot += parseFloat(sottoProgetto?.prezzo?.toString()) ?? 0;
    })
    return tot;
  }

  bancaChange(item) {
    console.log(item)
    if (item)
      item.banca = item.bancaObject?.id;
  }

  InviaEmail(item: any) {
    var emailmodal = this.ngbModal.open(PrintEmailComponent, { centered: true, backdrop: 'static', size: 'xl', });
    (<PrintEmailComponent>emailmodal.componentInstance).onSend.subscribe(tosend => this.apiPath.ClassicPost(`${this.restRoute}/send`, tosend).subscribe(() => { }));
    (<PrintEmailComponent>emailmodal.componentInstance).Send = {
      id: this.ProgettoSelezionato.id,
      subject: item.description,
      body: `Spett.le ${this.ProgettoSelezionato?.clienteObject?.nominativo},\n\ncon la presente inviamo in allegato l’ordine di acquisto confermato.\nDa questo momento il documento è esecutivo e verrà messo in evasione secondo le condizioni commerciali definite.\nAll’interno dell’Area Riservata è possibile verificare lo stato della spedizione.\n\nIl nostro team è a completa disposizione per qualsiasi chiarimento o necessità.\n\nGrazie.\n\nUfficio Commerciale\nKlimaitalia - LA MITO srl Distribuzione`,
      stampa: item?.id
    };
  }

  setDate() {
    this.ProgettoSelezionato.data_creazione = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.ProgettoSelezionato.data_emissione = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.ProgettoSelezionato.data_accettazione = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.ProgettoSelezionato.data_conferma = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
  }
  includesExtensions(item: Files, extensions: string[]) {
    return !extensions.every(x => !item.file.includes(x));
  }
  download(file: Files) {
    console.log("download", file.id);
    this.sharedapirest.downloadFle(file.id).subscribe(data => {
      this.downloadService.downloadFile(data)
    });
  }
  view(item: Files) {
    var url = `${this.apiPath?.getBaseAPI()}/file/download/${item.id?.toString()}?token=${this.apiPath.token()}`
    console.log(url)
    window.open(url, "_blank");
  }
  getTextPec() {
    return "Si invia in allegato la accettazione di cui all’oggetto\nCordiali saluti\nVerifica SpA"
  }
  hasPecButton() {
    return this.ProgettoSelezionato?.id && this.ProgettoSelezionato.data_accettazione && environment.RmaAddOn['invioPec'];
  }
  SendPec() {
    // var mailText = `mailto:${this.ProgettoSelezionato.clienteObject.pec ?? this.ProgettoSelezionato.clienteObject.email ?? 'noEmailFound@verificaspa.it'}?subject=Accettazione Vs. proposta contrattuale per la verifica degli impianti elettrici di cui al DPR 462/01 del 22/10/2001 e assegnazione numero di pratica per impianto sito in:&body=${this.getTextPec()}`; // add the links to body
    // window.location.href = mailText;
    if (!this.ProgettoSelezionato.data_conferma) {
      this.ProgettoSelezionato.data_conferma = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
      this.save(false);
    }
  }
  SyncGamma() { 
    this.apiPath.ClassicPost(`/progetti/progetti/update/gamma`, { id: this.ProgettoSelezionato.id }).subscribe(data => {
      this.refresh();
    })
  }
  deletefile(file) {
    if (confirm("Sei sicuro di voler eliminare questo file?"))
      this.fileStore.deleteFile(file).subscribe((data) => {
        if (environment.ProgettiAddon['genericFiles'] && this.id_offerta) {
          this.apiPath.ClassicPost(`${this.restRoute}/files`, { id: this.id_offerta }).subscribe(data => this.genericFiles = data);
        }
      });
  }
  deleteSubproject(sottoprogetto) {
    if (confirm("Sei sicuro di voler eliminare questo elemento"))
      this.apiPath.ClassicPost('/progetti/progetti/delete/commessa', { id: sottoprogetto.id }).subscribe(x => {
        this.refresh();
      })
  }
  protected readonly encodeURIComponent = encodeURIComponent;
}
import { Pipe, PipeTransform } from '@angular/core';
import { CampoAggiuntivo, CampoUtility } from "../../shared/models/campo-aggiuntivo";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PrintEmailComponent } from "../print-email/print-email.component";
import { Files } from "../../shared/models/File";
import { DownloadService } from "../../shared/_services/download.service";
import { AuthenticationService } from "../../Login/_services/authentication.service";

@Pipe({
  name: 'SottoprogettiNascosti',
  pure: false
})
export class SottoprogettiNascosti implements PipeTransform {
  transform(items: any[], filter: boolean): any {
    if (!items || !filter) {
      return items;
    }

    return items.filter(item => item.hide == filter);
  }
}
